import { LeadStageType, ServiceType } from "@/context/LeadContext";

export interface PartnerProfile {
  id: string;
  name: string;
  phone: string;
  email: string;
  location: string;
  services: string[];
  active: boolean;
  latitude?: number;
  longitude?: number;
  radius?: number;
  sms_opt_out?: boolean;
}

export interface PartnerOutletContext {
  partner: PartnerProfile;
  updatePartner: (partner: PartnerProfile) => void;
}

export interface PartnerLead {
  id: string;
  name: string;
  phone: string;
  email?: string;
  service: ServiceType;
  timeframe: string;
  stage: LeadStageType;
  comments?: string;
  createdAt: string;
  updatedAt?: string;
  smsSent: boolean;
  linkOpened: boolean;
}

export interface PartnerActivityLead {
  id: string;
  name: string;
  stage: LeadStageType;
  createdAt: string;
  updatedAt: string;
}

export interface PartnerActivityNote {
  id: string;
  leadId: string;
  note: string;
  authorName: string;
  createdAt: string;
}

export const PARTNER_STAGES: Array<{
  key: LeadStageType;
  label: string;
  shortLabel: string;
  dotClass: string;
  badgeClass: string;
  panelClass: string;
}> = [
  {
    key: "Νέο",
    label: "Νέα",
    shortLabel: "Νέα",
    dotClass: "bg-violet-500",
    badgeClass: "border-violet-200 bg-violet-50 text-violet-700",
    panelClass: "border-violet-200 bg-violet-50/55",
  },
  {
    key: "σεΕκκρεμότητα",
    label: "Σε εκκρεμότητα",
    shortLabel: "Εκκρεμή",
    dotClass: "bg-amber-500",
    badgeClass: "border-amber-200 bg-amber-50 text-amber-700",
    panelClass: "border-amber-200 bg-amber-50/55",
  },
  {
    key: "ήθελεΠληροφορίες",
    label: "Ζήτησαν πληροφορίες",
    shortLabel: "Πληροφορίες",
    dotClass: "bg-sky-500",
    badgeClass: "border-sky-200 bg-sky-50 text-sky-700",
    panelClass: "border-sky-200 bg-sky-50/55",
  },
  {
    key: "έκλεισεΗΔουλειά",
    label: "Έκλεισαν",
    shortLabel: "Έκλεισαν",
    dotClass: "bg-emerald-500",
    badgeClass: "border-emerald-200 bg-emerald-50 text-emerald-700",
    panelClass: "border-emerald-200 bg-emerald-50/55",
  },
];

export const SERVICE_LABELS: Record<string, string> = {
  εξοικονομώ: "Εξοικονομώ",
  αντλίεςΘερμότητας: "Αντλίες θερμότητας",
  φωτοβολταϊκά: "Φωτοβολταϊκά",
  κλιματιστικά: "Κλιματιστικά",
  φυσικόΑέριο: "Φυσικό αέριο",
  ηλιακά: "Ηλιακά",
  ανακαινίζωΕνεργειακά: "Ανακαινίζω - Ενεργειακά συστήματα",
  ανακαινίζωΠλήρηςΑνακαίνιση: "Ανακαινίζω - Πλήρης ανακαίνιση",
  άλλο: "Άλλο",
};

export const TIMEFRAME_LABELS: Record<string, string> = {
  άμεσα: "Άμεσα",
  εντός3μηνών: "Εντός 3 μηνών",
  κάνωΈρευνα: "Κάνει έρευνα",
};

export const stageMeta = (stage: LeadStageType) =>
  PARTNER_STAGES.find((item) => item.key === stage) ?? PARTNER_STAGES[0];

export const parsePortalDate = (value: string): Date => {
  const normalized = value.includes("T") ? value : value.replace(" ", "T");
  return new Date(normalized);
};
